module.exports = __webpack_public_path__ + "static/future-of-work-what-ufos-can-teach-us-about-remote-work-3a8284df37d3f1d4ec3ce7c352bce9c3.png";